<template>
  <div>
    <span :class="{'m--margin-right-10': !toggleMore}">
      {{$t('Accept terms')}}
      <template v-if="isTermsPageSet">
        <a href="#" @click="showTermsModal">{{$t('Terms')}}</a>
      </template>
      <template v-else>
        {{$t('Terms')}}
      </template>
      {{$t('And')}}
      <a href="#" @click="showPrivacyPolicyModal">{{$t('Privacy')}}</a>.
    </span>
    <span v-if="toggleMore">
      {{$t('Terms agreement text')}}
    </span>
    <a @click="toggleMore = !toggleMore" class="bold pointer">{{ toggleMoreText }}</a>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import {PAGE, PRIVACY_POLICY} from "@/utils/PageModalTypes";

  export default {
    name: "RequiredAgreement",
    props: {
      openInModal: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        toggleMore: false
      }
    },
    methods: {
      ...mapActions([
        'setPageModal'
      ]),
      showTermsModal() {
        if (this.openInModal) {
          this.setPageModal({
            show: true,
            type: PAGE,
            title: this.$t('Terms'),
            content: 'terms/' + this.entityUuid
          });
        } else {
          this.$router.push({name: 'CustomPage', params: {pageUuid: 'terms'}})
        }
      },
      showPrivacyPolicyModal() {
        if (this.openInModal) {
          this.setPageModal({
            show: true,
            type: PRIVACY_POLICY,
            title: this.$t('Privacy Policy'),
            content: ''
          });
        } else {
          this.$router.push({name: 'PrivacyPolicyPage'})
        }
      },
    },
    computed: {
      ...mapState({
        entityUuid: state => state.auth.entity.uuid,
        isTermsPageSet: state => state.settings.termsPageUuid !== null,
        isPrivacyPageSet: state => state.settings.privacyPageUuid !== null,
        termsPageUuid: state => state.settings.termsPageUuid
      }),
      toggleMoreText() {
        return this.toggleMore
          ? this.$t('Show less')
          : this.$t('Show more')
      }
    }
  }
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
